module.exports = __webpack_public_path__ + "static/media/14UNEP5.691a4e66.jpg";